var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lecture
    ? _c(
        "div",
        { staticClass: "row course-lecture-item" },
        [
          _c(
            "div",
            {
              staticClass:
                "col align-self-center course-lecture-item__position-col typography--color-primary text-right"
            },
            [
              _c("span", { staticClass: "course-lecture-item__position" }, [
                _vm._v("\n      " + _vm._s(_vm.position) + "\n    ")
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "col-3 course-lecture-item__thumbnail-col text-center",
              attrs: {
                to: _vm.$route.path + "/lectures/" + _vm.lecture.id,
                tag: "div"
              }
            },
            [
              _c("div", {
                staticClass: "course-lecture-item__thumbnail",
                style: _vm.lectureThumbStyle
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "col course-lecture-item__info-col",
              attrs: {
                to: _vm.$route.path + "/lectures/" + _vm.lecture.id,
                tag: "div"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-1 typography--font-weight-600 mb-1 course-lecture-item__title"
                },
                [_vm._v("\n      " + _vm._s(_vm.lecture.title) + "\n    ")]
              ),
              _vm._v(" "),
              _vm.domainName || _vm.domainConceptName
                ? _c(
                    "div",
                    {
                      staticClass:
                        "typography--caption typography--color-secondary"
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.domainName) +
                            " " +
                            _vm._s(_vm.domainConceptName) +
                            "\n      "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "typography--caption typography--color-secondary"
                },
                [
                  _c("small", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                        "\n        " +
                        _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                        "\n        - " +
                        _vm._s(
                          _vm.getShareLevelLabel(_vm.lecture.share_level || 2)
                        ) +
                        "\n      "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.lectureDescription
                ? _c(
                    "div",
                    { staticClass: "typography--caption break-word-all" },
                    [
                      _c("small", {
                        domProps: { innerHTML: _vm._s(_vm.lectureDescription) }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "typography--caption typography--color-disabled"
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("common.terms.no_description")) +
                            "\n      "
                        )
                      ])
                    ]
                  )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col align-self-center course-lecture-item__menu-col"
            },
            [
              _c(
                "IconDropdown",
                [
                  _c(
                    "b-dropdown-item",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        to:
                          _vm.$route.path +
                          "/lectures/" +
                          _vm.lecture.id +
                          "/edit"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("video_lectures.video_lecture.edit")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "course-lecture-item__drag-handle" }, [
      _c("img", {
        attrs: {
          src: "/static/images/baseline-drag_handle-24px.svg",
          alt: "drag handle"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc5d20e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc5d20e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-courses/components/CourseLectureItem.vue
// module id = Sl0p
// module chunks = 1